// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1___d5de8372f069f746e5d","cls2":"PaperAbstract-cls2__b5108e9a4fc6339f472a PaperAbstract-cls1___d5de8372f069f746e5d"};